import { DateWithTimezones } from '../../common';

export interface ShipmentCommentsModel {
  id: number;
  fullName: string;
  createdAt: DateWithTimezones;
  comment: string;
}
